class Table extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="table">
          Table
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-textarea" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Tables</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="table-demo">
  <table>
    <thead>
      <tr>
        <th>Pokemon</th>
        <th>Number</th>
        <th>Type</th>
        <th>Height</th>
        <th>Weight</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Venasaur</td>
        <td>003</td>
        <td>Grass/Poison</td>
        <td>2m</td>
        <td>100kg</td>
      </tr>
      <tr>
        <td>Charizard</td>
        <td>006</td>
        <td>Fire/Flying</td>
        <td>1.7m</td>
        <td>90.5kg</td>
      </tr>
      <tr>
        <td>Blastoise</td>
        <td>009</td>
        <td>Water</td>
        <td>1.6m</td>
        <td>85.5kg</td>
      </tr>
    </tbody>
  </table>

  <table class="light">
    <thead>
      <tr>
        <th>Pokemon</th>
        <th>Number</th>
        <th>Type</th>
        <th>Height</th>
        <th>Weight</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td><span>Venasaur</span></td>
        <td><span>003</span></td>
        <td><span>Grass/Poison</span></td>
        <td><span>2m</span></td>
        <td><span>100kg</span></td>
      </tr>
      <tr>
        <td><span>Charizard</span></td>
        <td><span>006</span></td>
        <td><span>Fire/Flying</span></td>
        <td><span>1.7m</span></td>
        <td><span>90.5kg</span></td>
      </tr>
      <tr>
        <td><span>Blastoise</span></td>
        <td><span>009</span></td>
        <td><span>Water</span></td>
        <td><span>1.6m</span></td>
        <td><span>85.5kg</span></td>
      </tr>
    </tbody>
  </table>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.table-demo {
  table {
    @include table();
    margin-bottom: 20px;

    &.light {
      @include table(light);

      span {
        height: 40px;
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="table-demo">
                    <table>
                      <thead>
                        <tr>
                          <th>Pokemon</th>
                          <th>Number</th>
                          <th>Type</th>
                          <th>Height</th>
                          <th>Weight</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Venasaur</td>
                          <td>003</td>
                          <td>Grass/Poison</td>
                          <td>2m</td>
                          <td>100kg</td>
                        </tr>
                        <tr>
                          <td>Charizard</td>
                          <td>006</td>
                          <td>Fire/Flying</td>
                          <td>1.7m</td>
                          <td>90.5kg</td>
                        </tr>
                        <tr>
                          <td>Blastoise</td>
                          <td>009</td>
                          <td>Water</td>
                          <td>1.6m</td>
                          <td>85.5kg</td>
                        </tr>
                      </tbody>
                    </table>

                    <table className="light">
                      <thead>
                        <tr>
                          <th>Pokemon</th>
                          <th>Number</th>
                          <th>Type</th>
                          <th>Height</th>
                          <th>Weight</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><span>Venasaur</span></td>
                          <td><span>003</span></td>
                          <td><span>Grass/Poison</span></td>
                          <td><span>2m</span></td>
                          <td><span>100kg</span></td>
                        </tr>
                        <tr>
                          <td><span>Charizard</span></td>
                          <td><span>006</span></td>
                          <td><span>Fire/Flying</span></td>
                          <td><span>1.7m</span></td>
                          <td><span>90.5kg</span></td>
                        </tr>
                        <tr>
                          <td><span>Blastoise</span></td>
                          <td><span>009</span></td>
                          <td><span>Water</span></td>
                          <td><span>1.6m</span></td>
                          <td><span>85.5kg</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
